module.exports = __webpack_public_path__ + "static/media/team-building.1ed87071.png";